import { useEffect } from 'react';
import type { Cart } from 'types/cart/Cart';

import { useAnalyticsDelegatorStore } from './useAnalyticsStore';
import { useScriptManagerStore } from './useScriptManagerStore';

export interface AddToCartSchema {
  cart: Cart;
  merchandiseIds: string[];
}

export const useAnalytics = () => {
  const scriptManager = useScriptManagerStore((state) => state.scriptManager);
  const analyticsDelegator = useAnalyticsDelegatorStore(
    (state) => state.analyticsDelegator,
  );
  const registerSinks = useAnalyticsDelegatorStore(
    (state) => state.registerSinks,
  );

  useEffect(() => {
    registerSinks(scriptManager);
  }, [registerSinks, scriptManager]);

  return { analytics: analyticsDelegator };
};
